import Survicate from '@survicate/survicate-web-package';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLazyGetAllUserCompletedSurveyNamesQuery, useMarkSurveyAsAnsweredForUserMutation } from '../apiRtk/be4feApi';
import { TYPE_DESCRIPTOR } from '../modules/notifications';
import { addSnackbarError } from '../modules/notifications/actions';
import messages from './messages';

export function useSurvicateEvent(eventName: string) {
  const dispatch = useDispatch();
  const [markSurveyAsAnsweredForUser] = useMarkSurveyAsAnsweredForUserMutation();
  const [getAllUserCompletedSurveyNames] = useLazyGetAllUserCompletedSurveyNamesQuery();
  const [surveyNames, setSurveyNames] = useState<string[]>([]);

  useEffect(() => {
    const fetchSurveyNames = async () => {
      try {
        const response = await getAllUserCompletedSurveyNames().unwrap();
        setSurveyNames(response.surveyNames);
      } catch (error) {
        // Error handling is not needed.
      }
    };

    fetchSurveyNames();
  }, [getAllUserCompletedSurveyNames]);

  const triggerSurveyEvent = useCallback(() => {
    if (!eventName || surveyNames.includes(eventName)) return;

    if (eventName && !surveyNames.includes(eventName)) {
      const handleComplete = () => {
        Survicate.removeEventListener(Survicate.ApiEvent.surveyCompleted);
        Survicate.removeEventListener(Survicate.ApiEvent.surveyClosed);
        markSurveyAsAnsweredForUser({
          userAnsweredSurveyRequest: { surveyName: eventName },
        })
          .unwrap()
          .catch(() => {
            dispatch(addSnackbarError({ ...messages.SurveyAnswerError }, TYPE_DESCRIPTOR));
          });
      };

      Survicate.addEventListener(Survicate.ApiEvent.surveyCompleted, handleComplete);
      Survicate.addEventListener(Survicate.ApiEvent.surveyClosed, handleComplete);
      Survicate.invokeEvent(eventName);
    }
  }, [eventName, surveyNames, markSurveyAsAnsweredForUser]);

  return {
    triggerSurveyEvent,
  };
}
